import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';
import debounce from "lodash/debounce"; //debounce防抖操作
import http from './utils/http';
import './index.scss';
import './directives'
Vue.use(Antd);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
// plugins
import './plugins/vue-layer';


Vue.prototype.$store = store;

Vue.config.productionTip = false;
Vue.prototype.$http = http;
// 组件
import BreadCrumb from './components/BreadCrumb/index';
import PopconfirmButton from './components/PopconfirmButton/index';
import BasicForm from './components/form/index';
import GradeSelect from './components/GradeSelect/index';
import FormButton from './components/FormButton/index';
import CutRule from './components/CutRule/index';
import FormCard from './components/FormCard/index';
import TableSearch from './components/TableSearch/index';
import ProvinceCity from './components/ProvinceCity/index';

Vue.component('bread-crumb', BreadCrumb);
Vue.component('popconfirm-button', PopconfirmButton);
Vue.component('basic-form', BasicForm);
Vue.component('grade-input-select', GradeSelect);
Vue.component('form-button', FormButton);
Vue.component('cut-rule', CutRule);
Vue.component('form-card', FormCard);
Vue.component('table-search', TableSearch);
Vue.component('province-city', ProvinceCity);

// 自定义图标
import { Icon } from 'ant-design-vue';
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1595715_dnlaxrfu7mc.js',
});
Vue.component('icon-font', IconFont);

// 全局设置默认语言
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
Vue.prototype.$moment = moment;
// 时间戳转monment
Vue.prototype.$Moment = (time) => moment.unix(time);
// 显示时间
Vue.prototype.$Format = (time) => moment.unix(time).format('YYYY-MM-DD HH:mm:ss');
// moment转日期
Vue.prototype.$Date = (time) => time.format('YYYY-MM-DD');
// 转时间戳
Vue.prototype.$Times = (time) => moment(time).unix();

// 设置全局提示配置
import { message } from 'ant-design-vue';
Vue.prototype.$message = message;
message.config({
  maxCount: 1,
});

// 上传域名设置
// Vue.prototype.uploadUrl = process.env.NODE_ENV === 'development' ? 'https://partner.neweasygo.com/v1/' : '/v1/';
// Vue.prototype.doctorUpload = process.env.NODE_ENV === 'development' ? 'https://partner-test.neweasygo.com/' : '';
Vue.prototype.uploadUrl = process.env.NODE_ENV === 'development' ? 'http://dengji.local.com/v1/' : '/v1/';

// 全局设置api
Vue.prototype.$api = process.env.NODE_ENV === 'production' ? '' : '/api';

const vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
export default vue;

